export type SettingsRole = 'owner' | 'admin' | 'member';

export interface SettingsSection {
  id: string;
  group: 'you' | 'workspace';
  labelKey: string;
  icon: string;
}

const YOU_SECTIONS: SettingsSection[] = [
  { id: 'profile', group: 'you', labelKey: 'settingsNavProfile', icon: 'badge' },
  { id: 'ai-pref', group: 'you', labelKey: 'settingsNavAiPref', icon: 'tune' },
  { id: 'style', group: 'you', labelKey: 'settingsNavStyle', icon: 'ink_pen' },
  { id: 'ai-work', group: 'you', labelKey: 'settingsNavAiWork', icon: 'work' },
  { id: 'my-connections', group: 'you', labelKey: 'settingsNavMyConnections', icon: 'key' },
  { id: 'advanced', group: 'you', labelKey: 'settingsNavAdvanced', icon: 'discover_tune' },
];

const WORKSPACE_SECTIONS: SettingsSection[] = [
  { id: 'members', group: 'workspace', labelKey: 'settingsNavMembers', icon: 'group_add' },
  { id: 'integration-policy', group: 'workspace', labelKey: 'settingsNavIntegrationPolicy', icon: 'policy' },
  { id: 'sync-rules', group: 'workspace', labelKey: 'settingsNavSyncRules', icon: 'sync' },
];

// Section visibility remains role-independent when the explicit deployment
// capability is enabled: member can view workspace sections read-only. A role
// never enables this surface by itself.
export function visibleSections(_role: SettingsRole, workspaceAdminEnabled = false): SettingsSection[] {
  return workspaceAdminEnabled ? [...YOU_SECTIONS, ...WORKSPACE_SECTIONS] : [...YOU_SECTIONS];
}

export function isSettingsHash(hash: string): boolean {
  return hash === '#settings' || hash.startsWith('#settings-');
}

// #2762: 「いつも使うサービス」 and 「AIに任せる作業」 became one section; old links still land there.
const SECTION_ALIASES: Record<string, string> = { where: 'ai-work', 'auto-exec': 'ai-work' };

export function resolveSettingsHash(hash: string, sectionIds: readonly string[]): string {
  const first = sectionIds[0] || '';
  if (hash === '#settings') return first;
  const raw = hash.startsWith('#settings-') ? hash.slice('#settings-'.length) : '';
  const candidate = SECTION_ALIASES[raw] ?? raw;
  return sectionIds.includes(candidate) ? candidate : first;
}

export function settingsHash(sectionId: string): string {
  return `#settings-${sectionId}`;
}

// The Settings shell is one browser-history destination. Section changes update
// the current entry, avoiding a Back-stack entry for every nav click.
export function settingsHistoryMode(_fromHash: string, _toHash: string): 'replace' {
  return 'replace';
}
